module.exports = __webpack_public_path__ + "static/media/stream-netflix-in-your-c-sharp-program.38c82e0b.md";